import {OrderStatusTypes} from "./enum";
import {grey} from "@mui/material/colors";

// export const OrderStatusColors: { [key in OrderStatusTypes]: string }= {
//     [OrderStatusTypes.PENDING]: '#FFD700',
//     [OrderStatusTypes.DELIVERED]: '#32CD32',
//     [OrderStatusTypes.CANCELLED]: '#DC143C',
//     [OrderStatusTypes.DELAYED]: '#FFA500',
// }

const OrderStatusColors: Record<OrderStatusTypes, string> = {
    [OrderStatusTypes.PENDING]: '#87CEEB',
    [OrderStatusTypes.DELIVERED]: '#32CD32',
    [OrderStatusTypes.CANCELLED]: '#DC143C',
    [OrderStatusTypes.DELAYED]: '#FFC107',
}

export const getOrderStatusColor = (status: OrderStatusTypes) => OrderStatusColors[status] || grey[400]